// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#AdminUserProfileEdit.page-content {
  max-height: 100vh;
  overflow: hidden;
  justify-content: flex-start;
}
#AdminUserProfileEdit .editor-wrapper {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: row;
}
#AdminUserProfileEdit .editor-wrapper .clipboard-area {
  border-radius: 8px;
  overflow: hidden;
  border: solid 1px var(--border-color);
}
#AdminUserProfileEdit .editor-wrapper .clipboard-area .textinput {
  border: none;
}
#AdminUserProfileEdit .editor-wrapper .clipboard-area .tag-input {
  padding-right: 48px;
  min-width: 280px;
}
#AdminUserProfileEdit .editor-wrapper .clipboard-area .clipboard-button {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  width: 40px;
  height: 40px;
  border-left: solid 1px var(--border-color);
  border-radius: 0;
  background-color: var(--white-color-lightest);
  color: var(--font_active_sub_color);
}
#AdminUserProfileEdit .editor-wrapper .clipboard-area .clipboard-button:hover {
  background-color: var(--white-color-main);
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer {
  min-width: 64px;
  height: 100%;
  max-height: 100vh;
  transition: min-width 0.3s ease;
  background-color: var(--white-color-lightest);
  border-right: solid 1px var(--border-weak-color);
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .drawer-header {
  height: 48px;
  border-bottom: 1px solid var(--white-color-dark);
  padding: 8px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .drawer-header .drawer-close-button {
  width: 100%;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .drawer-content {
  padding: 32px 32px;
  padding-top: 16px;
  min-height: calc(100vh - 0px);
  overflow-y: scroll;
  overflow-x: hidden;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .drawer-content::-webkit-scrollbar {
  display: none;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .editor-drawer-setting, #AdminUserProfileEdit .editor-wrapper .editor-drawer .editor-drawer-movie {
  opacity: 0;
  transition: opacity 0.3s;
  display: none;
  min-width: 360px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .editor-drawer-setting.show, #AdminUserProfileEdit .editor-wrapper .editor-drawer .editor-drawer-movie.show {
  opacity: 1;
  display: initial;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .back-button .button-label {
  height: 100%;
  width: 100%;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .movie-up-button {
  background-color: var(--input-bg-color);
  border: dashed 2px var(--border-color);
  color: var(--font_active_sub_color);
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .movie-up-button:hover {
  background-color: var(--disabled-bg-color);
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .delete-button {
  height: 28px;
  min-height: 28px;
  padding: 4px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row {
  height: 240px;
  padding: 0;
  border: solid 1px var(--border-color);
  position: relative;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button::after, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: var(--white-color-lightest-transparent-25);
  z-index: var(--z-index-local-over-1);
  opacity: 0;
  transition: opacity 0.3s;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button:hover::after, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row:hover::after {
  opacity: 1;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button .check-mark, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row .check-mark {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  top: -11px;
  right: -11px;
  border-radius: 11px;
  background-color: var(--primary-color-main);
  z-index: var(--z-index-local-over-2);
  opacity: 0;
  transition: opacity 0.3s;
  color: var(--white-color-lightest);
  padding-top: 1px;
  padding-left: 1px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button.selected, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row.selected {
  box-shadow: 0 0 0 2.5px var(--primary-color-main);
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button.selected .check-mark, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row.selected .check-mark {
  opacity: 1;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button .video-label, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row .video-label {
  padding: 16px 8px;
  border-bottom: solid 1px var(--border-color);
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button .button-label, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row .button-label {
  height: 100%;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button .video, #AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row .video {
  border-radius: 0px 0px 8px 8px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row {
  height: 96px;
  border-radius: 4px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row .video-label {
  padding: 16px;
  border-bottom: none;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer .video-button-row .video {
  width: 35%;
  border-radius: 0px 4px 4px 0px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer.expand {
  min-width: 420px;
}
#AdminUserProfileEdit .editor-wrapper .editor-drawer.expand .drawer-close-button {
  width: 32px;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview {
  position: relative;
  border-radius: 8px;
  border: solid 1px var(--border-weak-color);
  min-height: 58px;
  padding: 16px;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .drawer-preview-label {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;
  padding: 0px 8px;
  color: var(--font_active_sub_color);
  background-color: var(--white-color-lightest);
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .preview-button {
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-family: "Yu Gothic", YuGothic, "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, Arial, "メイリオ", Meiryo, sans-serif;
  line-height: unset;
  transition: background-color 0.3s;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .preview-button.small {
  font-size: 12px;
  height: 35px;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .chat-input-area {
  display: flex;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .chat-input {
  flex: 1 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 12px;
  line-height: 1.5;
  font-family: "Yu Gothic", YuGothic, "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, Arial, "メイリオ", Meiryo, sans-serif;
  pointer-events: none;
  background-color: transparent;
  height: 35px;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .chat-messages {
  max-height: 150px;
  overflow-y: auto;
  background-color: transparent;
  font-size: 10px;
  line-height: 1.2;
  padding: 8px 4px;
  border-radius: 6px;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .preview-fullscreen-area {
  height: 170px;
  width: 100%;
  overflow: hidden;
  position: relative;
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .preview-fullscreen-area-message {
  height: fit-content;
  width: 100%;
  top: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  z-index: var(--z-index-local-over-1);
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .preview-fullscreen-area-message .top-message {
  color: #fff;
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 600;
  animation: fadeIn 2s ease-in-out;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
#AdminUserProfileEdit .editor-wrapper .drawer-preview .video {
  position: absolute;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-header {
  box-sizing: border-box;
  background-color: var(--white-color-lightest);
  padding: 16px;
  border-bottom: solid 1px var(--border-weak-color);
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content {
  padding: 32px;
  overflow-y: scroll;
  height: 100%;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content::-webkit-scrollbar {
  display: none;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content .quit-fullscreen-button {
  background-color: var(--white-color-lightest);
  border: solid 1px var(--border-color);
  border-radius: 8px;
  opacity: 0.5;
  position: absolute;
  top: 16px;
  left: 16px;
  width: fit-content;
  height: 32px;
  min-height: 32px;
  z-index: var(--z-index-local-over-1);
  display: none;
  color: var(--font_active_sub_color);
  padding: 8px 16px;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content .quit-fullscreen-button:hover {
  opacity: 1;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: var(--z-index-specific-overlay);
  padding: 0;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content.fullscreen .quit-fullscreen-button {
  display: block;
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content .preview-iframe-wrapper.sp {
  width: clamp(180px, 30vw, 430px);
}
#AdminUserProfileEdit .editor-wrapper .editor-preview .editor-preview-content .preview-iframe-wrapper.isloading {
  box-shadow: none;
}
#AdminUserProfileEdit .input-row-area-short {
  width: 50%;
}
#AdminUserProfileEdit .input-label-text {
  text-align: left;
  width: 18%;
}
#AdminUserProfileEdit .long-button {
  max-width: 20%;
}
#AdminUserProfileEdit .short-input {
  max-width: 20%;
}
#AdminUserProfileEdit .long-input {
  max-width: 52%;
}
#AdminUserProfileEdit .addmergin {
  margin-top: 32px;
}
#AdminUserProfileEdit .fade-in {
  opacity: 1;
  z-index: var(--z-index-local-over-1);
}
#AdminUserProfileEdit .fade-out {
  opacity: 0;
  z-index: var(--z-index-local-default);
}
#AdminUserProfileEdit .input-required-mark {
  color: var(--primary-color-main);
  font-size: var(--text-size-small);
  font-weight: 600;
}
#AdminUserProfileEdit .layout-switch .icon {
  color: var(--dark-color-light);
}
#AdminUserProfileEdit .theme-switch .icon {
  color: var(--white-color-lightest);
}
#AdminUserProfileEdit .theme-switch .inactive .icon {
  color: var(--dark-color-light);
}
#AdminUserProfileEdit .theme-switch.value-light .cursor {
  background-color: #ff8a46;
}
#AdminUserProfileEdit .theme-switch.value-dark .cursor {
  background-color: #a46cfe;
}
#AdminUserProfileEdit .typing-effect-switch span {
  width: 64px;
}
#AdminUserProfileEdit .open-mode-switch span {
  width: 64px;
}
#AdminUserProfileEdit .dest-page-url.hidden {
  display: none;
}
#AdminUserProfileEdit .page-download-button {
  border-radius: 14px;
  font-size: var(--text-size-normal);
  height: 28px;
  margin-top: 24px;
  min-height: 28px;
  padding: 0;
  display: none;
}
#AdminUserProfileEdit .page-download-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserProfileEdit .page-attention-text {
  font-weight: normal;
  margin-top: 4px;
  padding-left: 12px;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserProfileEdit.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,iBAAA;EACA,gBAAA;EACA,2BAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EAEA,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,kBAAA;EACA,gBAAA;EACA,qCAAA;AADN;AAGM;EACE,YAAA;AADR;AAIM;EACE,mBAAA;EACA,gBAAA;AAFR;AAIM;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EAEA,WAAA;EACA,YAAA;EAEA,0CAAA;EAEA,gBAAA;EACA,6CAAA;EACA,mCAAA;AALR;AAOQ;EACE,yCAAA;AALV;AAUI;EAEE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EAEA,6CAAA;EACA,gDAAA;AAVN;AAYM;EACE,YAAA;EACA,gDAAA;EACA,YAAA;AAVR;AAYQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAVV;AAcM;EAEE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AAbR;AAeQ;EACE,aAAA;AAbV;AAiBM;EACI,UAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;AAfV;AAiBU;EACI,UAAA;EACA,gBAAA;AAfd;AAoBQ;EACE,YAAA;EACA,WAAA;AAlBV;AAsBM;EACE,uCAAA;EACA,sCAAA;EACA,mCAAA;AApBR;AAsBQ;EACE,0CAAA;AApBV;AAwBM;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AAtBR;AAyBM;EACE,aAAA;EACA,UAAA;EAEA,qCAAA;EACA,kBAAA;AAxBR;AA0BQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,4DAAA;EACA,oCAAA;EACA,UAAA;EACA,wBAAA;AAxBV;AA0BQ;EACE,UAAA;AAxBV;AA2BQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,oCAAA;EACA,UAAA;EACA,wBAAA;EACA,kCAAA;EACA,gBAAA;EACA,iBAAA;AAzBV;AA2BQ;EACE,iDAAA;AAzBV;AA0BU;EACE,UAAA;AAxBZ;AA4BQ;EACE,iBAAA;EACA,4CAAA;AA1BV;AA6BQ;EACE,YAAA;AA3BV;AA8BQ;EACE,8BAAA;AA5BV;AAgCM;EACE,YAAA;EACA,kBAAA;AA9BR;AAgCQ;EACE,aAAA;EACA,mBAAA;AA9BV;AAiCQ;EACE,UAAA;EACA,8BAAA;AA/BV;AAmCM;EAEE,gBAAA;AAlCR;AAoCQ;EACE,WAAA;AAlCV;AAuCI;EACE,kBAAA;EACA,kBAAA;EACA,0CAAA;EAEA,gBAAA;EAEA,aAAA;AAvCN;AAyCM;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,6CAAA;AAvCR;AA0CM;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kHAAA;EACA,kBAAA;EACA,iCAAA;AAxCR;AA0CQ;EACE,eAAA;EACA,YAAA;AAxCV;AA4CM;EACE,aAAA;EACA,yBAAA;EACA,0BAAA;AA1CR;AA6CM;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kHAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;AA3CR;AA8CM;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA5CR;AA+CM;EAEE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA9CR;AAiDM;EAEE,mBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AAhDR;AAkDQ;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yCAAA;AAhDV;AAoDM;EACE,kBAAA;AAlDR;AAuDI;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AArDN;AAuDM;EACE,sBAAA;EACA,6CAAA;EACA,aAAA;EAEA,iDAAA;AAtDR;AAyDM;EACE,aAAA;EACA,kBAAA;EACA,YAAA;AAvDR;AAyDQ;EACE,aAAA;AAvDV;AA0DQ;EACE,6CAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,mCAAA;EACA,iBAAA;AAxDV;AA0DU;EACE,UAAA;AAxDZ;AA4DQ;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EAEA,UAAA;AA3DV;AA6DU;EACE,cAAA;AA3DZ;AAgEU;EACE,gCAAA;AA9DZ;AAkEQ;EACE,gBAAA;AAhEV;AAuEE;EACI,UAAA;AArEN;AAwEE;EACI,gBAAA;EACA,UAAA;AAtEN;AAwEE;EACI,cAAA;AAtEN;AAwEE;EACI,cAAA;AAtEN;AAwEE;EACE,cAAA;AAtEJ;AAwEE;EACI,gBAAA;AAtEN;AAyEE;EACE,UAAA;EACA,oCAAA;AAvEJ;AA0EE;EACE,UAAA;EACA,qCAAA;AAxEJ;AA2EE;EACE,gCAAA;EACA,iCAAA;EACA,gBAAA;AAzEJ;AA6EI;EACE,8BAAA;AA3EN;AAiFI;EACE,kCAAA;AA/EN;AAkFM;EACE,8BAAA;AAhFR;AAsFM;EACE,yBAAA;AApFR;AAwFM;EACE,yBAAA;AAtFR;AA4FI;EACE,WAAA;AA1FN;AA+FI;EACE,WAAA;AA7FN;AAkGI;EACE,aAAA;AAhGN;AAoGE;EACE,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EAEA,aAAA;AAnGJ;AAsGE;EACE,wCAAA;EACA,8BAAA;AApGJ;AAuGE;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EAEA,aAAA;AAtGJ","sourcesContent":["#AdminUserProfileEdit{\r\n  &.page-content{\r\n    max-height: 100vh;\r\n    overflow: hidden;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .editor-wrapper{\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: 100vh;\r\n\r\n    display: flex;\r\n    flex-direction: row;\r\n\r\n    .clipboard-area{\r\n      border-radius: 8px;\r\n      overflow: hidden;\r\n      border: solid 1px var(--border-color);\r\n\r\n      .textinput{\r\n        border: none;\r\n      }\r\n\r\n      .tag-input{\r\n        padding-right: 48px;\r\n        min-width: 280px;\r\n      }\r\n      .clipboard-button{\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        margin: auto;\r\n        right: 0;\r\n\r\n        width: 40px;\r\n        height: 40px;\r\n\r\n        border-left: solid 1px var(--border-color);\r\n\r\n        border-radius: 0;\r\n        background-color: var(--white-color-lightest);\r\n        color: var(--font_active_sub_color);\r\n\r\n        &:hover{\r\n          background-color: var(--white-color-main);\r\n        }\r\n      }\r\n    }\r\n\r\n    .editor-drawer{\r\n      // width: 64px;\r\n      min-width: 64px;\r\n      height: 100%;\r\n      max-height: 100vh;\r\n      transition: min-width 0.3s ease;\r\n\r\n      background-color: var(--white-color-lightest);\r\n      border-right: solid 1px var(--border-weak-color);\r\n\r\n      .drawer-header{\r\n        height: 48px;\r\n        border-bottom: 1px solid var(--white-color-dark);\r\n        padding: 8px;\r\n\r\n        .drawer-close-button{\r\n          width: 100%;\r\n          height: 32px;\r\n          min-width: 32px;\r\n          min-height: 32px;\r\n        }\r\n      }\r\n\r\n      .drawer-content\r\n      {\r\n        padding: 32px 32px;\r\n        padding-top: 16px;\r\n        min-height: calc(100vh - 0px);\r\n        overflow-y: scroll;\r\n        overflow-x: hidden;\r\n\r\n        &::-webkit-scrollbar {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      .editor-drawer-setting, .editor-drawer-movie{\r\n          opacity: 0;\r\n          transition: opacity 0.3s;\r\n          display: none;\r\n          min-width: 360px;\r\n          \r\n          &.show{\r\n              opacity: 1;\r\n              display: initial;\r\n          }\r\n      }\r\n\r\n      .back-button{\r\n        .button-label{\r\n          height: 100%;\r\n          width: 100%;\r\n        }\r\n      }\r\n\r\n      .movie-up-button{\r\n        background-color: var(--input-bg-color);\r\n        border: dashed 2px var(--border-color);\r\n        color: var(--font_active_sub_color);\r\n\r\n        &:hover{\r\n          background-color: var(--disabled-bg-color);\r\n        }\r\n      }\r\n\r\n      .delete-button{\r\n        height: 28px;\r\n        min-height: 28px;\r\n        padding: 4px;\r\n      }\r\n\r\n      .video-button, .video-button-row{\r\n        height: 240px;\r\n        padding: 0;\r\n        // overflow: hidden;\r\n        border: solid 1px var(--border-color);\r\n        position: relative;\r\n\r\n        &::after{\r\n          content: \"\";\r\n          position: absolute;\r\n          width: 100%;\r\n          height: 100%;\r\n          top: 0;\r\n          bottom: 0;\r\n          left: 0;\r\n          right: 0;\r\n          margin: auto;\r\n          background-color: var(--white-color-lightest-transparent-25);\r\n          z-index: var(--z-index-local-over-1);\r\n          opacity: 0;\r\n          transition: opacity 0.3s;\r\n        }\r\n        &:hover::after{\r\n          opacity: 1;\r\n        }\r\n\r\n        .check-mark{\r\n          content: \"\";\r\n          position: absolute;\r\n          width: 22px;\r\n          height: 22px;\r\n          top: -11px;\r\n          right: -11px;\r\n          border-radius: 11px;\r\n          background-color: var(--primary-color-main);\r\n          z-index: var(--z-index-local-over-2);\r\n          opacity: 0;\r\n          transition: opacity 0.3s;\r\n          color: var(--white-color-lightest);\r\n          padding-top: 1px;\r\n          padding-left: 1px;\r\n        }\r\n        &.selected{\r\n          box-shadow: 0 0 0 2.5px var(--primary-color-main);\r\n          .check-mark{\r\n            opacity: 1;\r\n          }\r\n        }\r\n\r\n        .video-label{\r\n          padding: 16px 8px;\r\n          border-bottom: solid 1px var(--border-color);\r\n        }\r\n\r\n        .button-label{\r\n          height: 100%;\r\n        }\r\n\r\n        .video{\r\n          border-radius: 0px 0px 8px 8px;\r\n        }\r\n      }\r\n\r\n      .video-button-row{\r\n        height: 96px;\r\n        border-radius: 4px;\r\n\r\n        .video-label{\r\n          padding: 16px;\r\n          border-bottom:none;\r\n        }\r\n\r\n        .video{\r\n          width: 35%;\r\n          border-radius: 0px 4px 4px 0px;\r\n        }\r\n      }\r\n\r\n      &.expand{\r\n        // width: 420px;\r\n        min-width: 420px;\r\n\r\n        .drawer-close-button{\r\n          width: 32px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .drawer-preview{\r\n      position: relative;\r\n      border-radius: 8px;\r\n      border: solid 1px var(--border-weak-color);\r\n\r\n      min-height: 58px;\r\n\r\n      padding: 16px;\r\n\r\n      .drawer-preview-label{\r\n        position: absolute;\r\n        top: -10px;\r\n        left: 0;\r\n        right: 0;\r\n        margin: auto;\r\n        width: fit-content;\r\n        padding: 0px 8px;\r\n        color: var(--font_active_sub_color);\r\n        background-color: var(--white-color-lightest);\r\n      }\r\n\r\n      .preview-button{\r\n        border: none;\r\n        padding: 10px 20px;\r\n        border-radius: 5px;\r\n        cursor: pointer;\r\n        font-size: 16px;\r\n        font-family: \"Yu Gothic\", YuGothic, \"ヒラギノ角ゴ ProN W3\", Hiragino Kaku Gothic ProN, Arial, \"メイリオ\", Meiryo, sans-serif;\r\n        line-height: unset;\r\n        transition: background-color 0.3s;\r\n\r\n        &.small{\r\n          font-size: 12px;\r\n          height: 35px;\r\n        }\r\n      }\r\n\r\n      .chat-input-area {\r\n        display: flex;\r\n        background-color: #f9f9f9;\r\n        border-top: 1px solid #ddd;\r\n      }\r\n\r\n      .chat-input {\r\n        flex: 1;\r\n        padding: 10px;\r\n        border-radius: 5px;\r\n        border: 1px solid #ddd;\r\n        font-size: 12px;\r\n        line-height: 1.5;\r\n        font-family: \"Yu Gothic\", YuGothic, \"ヒラギノ角ゴ ProN W3\", Hiragino Kaku Gothic ProN, Arial, \"メイリオ\", Meiryo, sans-serif;\r\n        pointer-events: none;\r\n        background-color: transparent;\r\n        height: 35px;\r\n      }\r\n\r\n      .chat-messages {\r\n        max-height: 150px;\r\n        overflow-y: auto;\r\n        background-color: transparent;\r\n        font-size: 10px;\r\n        line-height: 1.2;\r\n        padding: 8px 4px;\r\n        border-radius: 6px;\r\n      }\r\n\r\n      .preview-fullscreen-area\r\n      {\r\n        height: 170px;\r\n        width: 100%;\r\n        overflow: hidden;\r\n        position: relative;\r\n      }\r\n\r\n      .preview-fullscreen-area-message\r\n      {\r\n        height: fit-content;\r\n        width: 100%;\r\n        top: 0;\r\n        bottom: 0;\r\n        margin: auto;\r\n        position: absolute;\r\n        z-index: var(--z-index-local-over-1);\r\n\r\n        .top-message{\r\n          color: #fff;\r\n          font-size: 18px;\r\n          margin-bottom: 10px;\r\n          font-weight: 600;\r\n          animation: fadeIn 2s ease-in-out;\r\n          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\r\n        }\r\n      }\r\n\r\n      .video{\r\n        position: absolute;\r\n        \r\n      }\r\n    }\r\n\r\n    .editor-preview{\r\n      width: 100%;\r\n      height: 100vh;\r\n      overflow: hidden;\r\n\r\n      .editor-header{\r\n        box-sizing: border-box;\r\n        background-color: var(--white-color-lightest);\r\n        padding: 16px;\r\n\r\n        border-bottom: solid 1px var(--border-weak-color);\r\n      }\r\n\r\n      .editor-preview-content{\r\n        padding: 32px;\r\n        overflow-y: scroll;\r\n        height: 100%;\r\n\r\n        &::-webkit-scrollbar {\r\n          display: none;\r\n        }\r\n\r\n        .quit-fullscreen-button{\r\n          background-color: var(--white-color-lightest);\r\n          border: solid 1px var(--border-color);\r\n          border-radius: 8px;\r\n          opacity: 0.5;\r\n          position: absolute;\r\n          top: 16px;\r\n          left: 16px;\r\n          width: fit-content;\r\n          height: 32px;\r\n          min-height: 32px;\r\n          z-index: var(--z-index-local-over-1);\r\n          display: none;\r\n          color: var(--font_active_sub_color);\r\n          padding: 8px 16px;\r\n\r\n          &:hover{\r\n            opacity: 1;\r\n          }\r\n        }\r\n\r\n        &.fullscreen{\r\n          position: fixed;\r\n          top: 0;\r\n          left: 0;\r\n          width: 100vw;\r\n          height: 100vh;\r\n          z-index: var(--z-index-specific-overlay);\r\n          \r\n          padding: 0;\r\n\r\n          .quit-fullscreen-button{\r\n            display: block;\r\n          }\r\n        }\r\n        \r\n        .preview-iframe-wrapper{\r\n          &.sp{\r\n            width: clamp(180px, 30vw , 430px);\r\n          }\r\n        }\r\n\r\n        .preview-iframe-wrapper.isloading{\r\n          box-shadow: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n\r\n  .input-row-area-short{\r\n      width: 50%;\r\n  }\r\n  \r\n  .input-label-text{\r\n      text-align: left;\r\n      width: 18%;\r\n  }\r\n  .long-button{\r\n      max-width: 20%\r\n  }\r\n  .short-input{\r\n      max-width: 20%\r\n  }\r\n  .long-input{\r\n    max-width: 52%\r\n  }\r\n  .addmergin{\r\n      margin-top: 32px;\r\n  }\r\n\r\n  .fade-in {\r\n    opacity: 1;\r\n    z-index: var(--z-index-local-over-1); \r\n  }\r\n\r\n  .fade-out {\r\n    opacity: 0;\r\n    z-index: var(--z-index-local-default);\r\n  }\r\n\r\n  .input-required-mark {\r\n    color: var(--primary-color-main);\r\n    font-size: var(--text-size-small);\r\n    font-weight: 600;\r\n  }\r\n\r\n  .layout-switch {\r\n    .icon {\r\n      color: var(--dark-color-light);\r\n    }\r\n  }\r\n\r\n  .theme-switch {\r\n\r\n    .icon{\r\n      color: var(--white-color-lightest);\r\n    }\r\n    .inactive{\r\n      .icon{\r\n        color : var(--dark-color-light);\r\n        \r\n      }\r\n    }\r\n\r\n    &.value-light{\r\n      .cursor{\r\n        background-color: #ff8a46;\r\n      }\r\n    }\r\n    &.value-dark{\r\n      .cursor{\r\n        background-color: #a46cfe;\r\n      }\r\n    }\r\n  }\r\n\r\n  .typing-effect-switch {\r\n    span {\r\n      width: 64px;\r\n    }\r\n  }\r\n\r\n  .open-mode-switch {\r\n    span {\r\n      width: 64px;\r\n    }\r\n  }\r\n\r\n  .dest-page-url {\r\n    &.hidden {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .page-download-button {\r\n    border-radius: 14px;\r\n    font-size: var(--text-size-normal);\r\n    height: 28px;\r\n    margin-top: 24px;\r\n    min-height: 28px;\r\n    padding: 0;\r\n\r\n    display: none;\r\n  }\r\n\r\n  .page-download-button:hover {\r\n    background-color: var(--dark-color-main);\r\n    color: var(--white-color-main);\r\n  }\r\n\r\n  .page-attention-text {\r\n    font-weight: normal;\r\n    margin-top: 4px;\r\n    padding-left: 12px;\r\n\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
